import { isObject, isArray, isString, isNil, has } from 'lodash';
import { DISABLED_VALUE } from '../../../constants';

const matrixRowMixin = {

    props: {
        questionIndex: Number,
        columns: Array,
        choice: [Object, Array],
        row: String,
        uukey: String,
        triggers: Object,
        answer: [String, Object, Array],
        disabled: Boolean,
        readOnly: Boolean,
        // disabledColumns: Array, <-- Sould be present as computed property
    },

    computed: {
        rowAnswer()
        {
            const choice = (has(this.choice, 'row')) ? this.choice.row : this.choice;
            if (!isObject(this.answer) || !has(this.answer, choice))
            {
                return {};
            }
            return this.answer[choice];
        },

        rowID()
        {
            return `r_${this.uukey}_${this.row}`;
        },

        rowDisabled()
        {
            if (this.disabled)
            {
                return true;
            }
            if (isNil(this.rowAnswer))
            {
                return false;
            }
            return this.rowAnswer == DISABLED_VALUE;
        },
    },

    methods: {

        isColumnDisabled(col)
        {
            if (isArray(this.disabledColumns))
            {
                return this.disabledColumns.indexOf(col) >= 0
            }
            return false;
        },
    },

};

export { matrixRowMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/matrix-row-mixin.js